<template>
  <div class="has-navbar-fixed-bottom" v-if="this.chapter !== 'load' && this.episode !== 'load'">
    <div class="card is-shadowless">
      <div class="card-header is-shadowless"><SideMenu></SideMenu>
      </div>
      <div class="card-content">
        <episode-title :title="episodes[episode].title"></episode-title>
        <p class="subtitle">{{chapterTitle(chapterId)}}</p>
        <ul>
          <li class="chapter-link is-size-5" :class="{read: isRead(key)}" v-for="(story, key) in currentChapter.titles" :key="key">
            <router-link @click.native="pushKey(key)" :to="'/story/' + episode + '/' + chapter + '/' + key">{{story}}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <nav class="navbar is-shadowless is-transparent is-fixed-bottom" role="navigation" aria-label="main navigation">
      <div class="navbar-menu is-shadowless is-active" style="display: flex;">
        <div class="navbar-start pl-4">
          <!-- navbar items -->
          <button class="button" @click="leaveNow">
            <span>Leave for now</span>
          </button>
        </div>
        <div class="navbar-end pr-4">
          <!-- navbar items -->
          <button class="button" v-if="completed && !storyEnd" @click="nextChapter">
            <span v-if="!episodeEnd">Next Chapter</span>
            <span v-if="episodeEnd">Finish Episode</span>
          </button>
          <button class="button" v-if="completed && storyEnd" @click="nextChapter">Finish</button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import config from '@/config.js'
import firebase from 'firebase'
import EpisodeTitle from '@/components/EpisodeTitle.vue'
var progRef = firebase.database().ref('/users/' + firebase.auth().currentUser.uid + '/progress')
export default {

  name: 'ChapterPage',

  data () {
    return {
      episodes: config.episodes
    }
  },
  components: {
    EpisodeTitle
  },
  computed: {
    episode () {
      if (!this.$attrs.episode) {
        return '1'
      } else if (this.$attrs.episode > this.$root.progress.episode && !this.$root.progress.debug && !this.$root.progress.finished) {
        if (this.$root.progress.episode === 0) {
          return 'load'
        }
        return this.$root.progress.episode.toString()
      } else {
        return this.$attrs.episode
      }
    },
    chapter () {
      if (!this.$attrs.chapter) {
        return '1'
      } else if (this.$attrs.chapter > this.$root.progress.chapter && !this.$root.progress.debug && !this.$root.progress.finished && parseInt(this.episode) === this.$root.progress.episode) {
        if (this.$root.progress.chapter === 0) {
          return 'load'
        }
        return this.$root.progress.chapter.toString()
      } else {
        return this.$attrs.chapter
      }
    },
    currentChapter () {
      if (this.chapter !== 'load' && this.episode !== 'load') {
        return this.episodes[this.episode].chapters[this.chapter]
      }
      return false
    },
    chapterId () {
      if (this.chapter !== 'load' && this.episode !== 'load') {
        return this.episodes[this.episode].chapters[this.chapter].id
      }
      return false
    },
    storiesRead () {
      return this.$root.progress.number_of_stories
    },
    completed () {
      if (typeof this.storiesRead === 'undefined') {
        return false
      }
      if (this.storiesRead.length >= this.currentChapter.storyCount) {
        return true
      }
      return false
    },
    episodeEnd () {
      if (this.chapter !== 'load' || this.episode !== 'load') {
        var nextCp = parseInt(this.chapter) + 1
        if (nextCp > this.episodes[this.episode].chapterCount) {
          return true
        }
        return false
      }
      return false
    },
    storyEnd () {
      if (parseInt(this.episode) === 4) {
        return true
      }
      return false
    },
    isMaxProgression () {
      if (parseInt(this.episode) === parseInt(this.$root.progress.episode)) {
        if (parseInt(this.chapter) === parseInt(this.$root.progress.chapter)) {
          return true
        }
        return false
      }
      return false
    }
  },
  methods: {
    pushKey (key) {
      var update = []
      if (typeof this.storiesRead !== 'undefined') {
        if (Array.isArray(this.storiesRead)) {
          update = this.storiesRead
        }
      }
      if (!update.includes(key) && parseInt(this.episode) === parseInt(this.$root.progress.episode) && parseInt(this.chapter) === parseInt(this.$root.progress.chapter)) {
        update.push(key)
        progRef.update({
          number_of_stories: update
        })
      }
    },
    isRead (key) {
      if (Array.isArray(this.storiesRead)) {
        if (this.storiesRead.includes(key)) {
          return true
        }
      }
      return false
    },
    chapterTitle (id) {
      var num
      if (id === 1) {
        num = 'One'
      } else if (id === 2) {
        num = 'Two'
      } else if (id === 3) {
        num = 'Three'
      } else if (id === 4) {
        num = 'Four'
      } else if (id === 5) {
        num = 'Five'
      }
      return 'Chapter ' + num
    },
    goBack: function () {
      this.$router.go(-1)
    },
    nextChapter (leave) {
      var nextEp = parseInt(this.episode)
      var nextCp = parseInt(this.chapter) + 1
      if (this.episodeEnd && !this.storyEnd) {
        nextEp++
        nextCp = 1
        progRef.update({ episodeEnded: Date.parse(new Date()) })
      }
      var forwardProgress = () => {
        if (this.$root.progress.debug) {
          return false
        }
        if (this.$root.progress.finished) {
          return true
        } else if (nextCp > this.$root.progress.chapter && nextEp >= this.$root.progress.episode) {
          return true
        } else if (nextEp > this.$root.progress.episode) {
          return true
        }
        return false
      }
      if (forwardProgress() && !this.storyEnd) {
        progRef.update({ episode: nextEp, chapter: nextCp, number_of_stories: 0 })
      } else if (this.storyEnd) {
        progRef.update({ number_of_stories: 0, finished: true })
      } else {
        progRef.update({ number_of_stories: 0 })
      }
      if (leave === 'leave') {
        this.$router.replace('/')
      } else {
        this.$router.replace('/location/' + nextEp + '/' + nextCp)
      }
    },
    leaveNow () {
      if (this.isMaxProgression) {
        if (this.completed && !this.storyEnd) {
          this.nextChapter('leave')
        } else {
          this.$alertify.confirm('If you leave without finishing the chapter you will have to return here to continue', () => {
            this.$router.replace('/')
          }).set({
            title: 'Be aware'
          }).set({
            labels: {
              ok: 'Leave',
              cancel: 'Stay'
            }
          })
        }
      } else {
        this.goBack()
      }
    }
  }
}
</script>

<style lang="css" scoped>
.chapter-link {
  text-align: left;
  border-bottom: 1px solid #bbb;
  margin-bottom: 0px;
  display: flex;
  position: relative;
}
.chapter-link:last-child {
  border: none;
}
.chapter-link a {
  padding: 0.5rem;
  display: flex;
  flex:2;
  color: #2c3e50;
}
.chapter-link:after {
  content: "";
  position: absolute;
  right: 0.5rem;
  top: calc(1.25rem - 1px);
  width: 0;
  height: 0;
  border-left: 0.5rem solid #bbb;
  border-top: 0.25rem solid transparent;
  border-bottom: 0.25rem solid transparent;
}
.chapter-link.read:after {
  display: inline-block;
  width: 0.4em;
  box-sizing: content-box;
  height: 0.4em;
  border: 0.1em solid #bbb;
  position: relative;
  border-radius: 0.35em;
}
</style>
